<template>
  <div class="form">
    <div class="vld-parent">
      <loading :active.sync="isLoading" :is-full-page="true"></loading>
    </div>
  <div>
    <form action="/" method="post" @submit.prevent="submitForm">
      <transition name="slide">
        <router-view />
      </transition>

      <div class="form-buttons nav-control">
        <template>
          <button
            type="button"
            class="btn btn-outline-secondary shadow-none"
            id="form-back"
            @click="previousStep"
          >
            Zurück
          </button>
          <button
            v-if="currentStep < totalSteps - 1"
            type="button"
            class="btn btn-primary shadow-none"
            id="form-forward"
            :class="!this.$store.getters.isValid ? 'disabled' : ''"
            @click="nextStep"
          >
            Weiter
          </button>
          <button
            id="form-forward"
            v-if="currentStep === totalSteps - 1"
            type="button"
            class="btn btn-primary shadow-none"
            @click="submitForm"
            :disabled="spinnerActive"
          >
            <b-spinner v-if="spinnerActive" small></b-spinner>
            <span v-if="!spinnerActive">Auftrag senden</span>
          </button>
        </template>
      </div>

      <div v-if="currentStep === totalSteps - 1" class="form-process-wrapper">
        <hr class="my-4" />
        <div class="form-mobile mobile-steps">
          <div class="footer-accordion">
            <b-card
              no-body
              class="mb-1"
              v-for="info in infoText"
              :key="info.id"
            >
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button
                  block
                  v-b-toggle="'info' + info.id"
                  variant="info"
                  class="form-footer-btn"
                >
                  <img
                    v-if="info.id === 1"
                    src="@/assets/images/overview/1.svg"
                    alt="Fertig"
                    style="width: 20px; height: 20px"
                  />
                  <img
                    v-if="info.id === 2"
                    src="@/assets/images/overview/2.svg"
                    alt="Schritt 2"
                  />
                  <img
                    v-if="info.id === 3"
                    src="@/assets/images/overview/3.svg"
                    alt="Schritt 3"
                  />
                  <span>{{ info.title }}</span>
                  <img
                    src="@/assets/images/help-center/down.svg"
                    class="accordion-icon"
                    alt="Down Icon"
                  />
                </b-button>
              </b-card-header>
              <b-collapse
                :id="'info' + info.id"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-card-text>
                    {{ info.text }}
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>
          </div>
        </div>
        <div class="form-tablet">
          <div class="form-footer-row">
            <div
              v-for="info in infoText.slice(0, 2)"
              :key="info.id"
              class="form-footer-steps"
            >
              <div class="form-footer-steps-title">
                <img
                  v-if="info.id === 1"
                  src="@/assets/images/overview/1.svg"
                  alt="Fertig"
                />
                <img
                  v-if="info.id === 2"
                  src="@/assets/images/overview/2.svg"
                  alt="Schritt 2"
                />
                <p>{{ info.title }}</p>
              </div>
              <span>{{ info.text }}</span>
            </div>
          </div>
          <hr class="my-4 tablet-separator" />
          <div class="form-footer-row">
            <div
              v-for="info in infoText.slice(2)"
              :key="info.id"
              class="form-footer-steps"
            >
              <div class="form-footer-steps-title">
                <img
                  v-if="info.id === 3"
                  src="@/assets/images/overview/3.svg"
                  alt="Schritt 3"
                />
                <p>{{ info.title }}</p>
              </div>
              <span>{{ info.text }}</span>
            </div>
          </div>
        </div>
        <div class="form-desktop">
          <div class="form-footer-row">
            <div
              v-for="info in infoText"
              :key="info.id"
              class="form-footer-steps"
            >
              <div class="form-footer-steps-title">
                <img
                  v-if="info.id === 1"
                  src="@/assets/images/overview/1.svg"
                  alt="Fertig"
                />
                <img
                  v-if="info.id === 2"
                  src="@/assets/images/overview/2.svg"
                  alt="Schritt 2"
                />
                <img
                  v-if="info.id === 3"
                  src="@/assets/images/overview/3.svg"
                  alt="Schritt 3"
                />
                <p>{{ info.title }}</p>
              </div>
              <span>{{ info.text }}</span>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import "vue-loading-overlay/dist/vue-loading.css";
import Compressor from 'compressorjs';

export default {
  name: "Form",
  components: {
    Loading
  },
  data() {
    return {
      isLoading: false,
      spinnerActive: false,
      totalSteps:
        this.$router.options.routes[this.$router.options.routes.length - 1]
          .children.length,
      infoText: [
        {
          id: 1,
          title: "Auftrag erfassen",
          text: "Unser System ermittelt basierend auf Ihren Antworten die notwendigen Service-Leistungen. \n\nBei Rückfragen zum Schaden werden wir mit Ihnen Kontakt aufnehmen.",
        },
        {
          id: 2,
          title: "Versand",
          text: "Sie versenden den Artikel an die CHRIST-Service-Werkstatt in einem geeigneten Paket (kein Luftpolsterumschlag). Sobald das Paket bei uns angekommen ist, bestätigen wir Ihnen den Erhalt per E-Mail.",
        },
        {
          id: 3,
          title: "Reparatur/Anfertigung/Umarbeitung",
          text:
            "Nach abgeschlossener Reparatur/Anfertigung/Umarbeitung erfolgt der kostenfreie Rückversand des Artikels, sowie der Rechnung an die von Ihnen angegebene Adresse." +
            "\nBei Unklarheiten oder Preisabweichungen nehmen wir direkt Kontakt mit Ihnen auf und Sie erhalten einen verbindlichen Kostenvoranschlag.",
        },
      ],
    };
  },
  computed: {
    currentStep() {
      return this.$store.state.currentStep;
    },
  },
  mounted() {
    this.$store.commit(
      "setTotalSteps",
      this.$router.options.routes[this.$router.options.routes.length - 1]
        .children.length
    );
    let externalScript = document.createElement("script");
    externalScript.setAttribute(
      "src",
      `https://www.google.com/recaptcha/api.js?render=6Ld-2D0jAAAAAO_Opw2GEf2isCYtdWF_X1l_8fiE`
    );
    document.head.appendChild(externalScript);
  },
  methods: {
    previousStep: function () {
      if (this.currentStep) {
        this.$router
          .push({
            name: this.$router.options.routes[
              this.$router.options.routes.length - 1
            ].children[this.currentStep - 1].name,
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.$router.push({ name: "Cart" }).catch((error) => {
          console.log(error);
        });
      }
    },
    nextStep() {
      if (this.validateStep()) {
        this.$router.push({
          name: this.$router.options.routes[
            this.$router.options.routes.length - 1
          ].children[this.currentStep + 1].name,
        });
      }
    },
    validateStep() {
      this.$store.state.validation.$touch();
      if (this.$store.state.validation.$invalid) {
        return false;
      } else {
        return true;
      }
    },
    async submitForm() {
      if (this.validateStep()) {
        this.isLoading = true;
        this.spinnerActive = true;
        var formData = new FormData();
        const images = this.$store.state.checkoutFormData.images;
        for (let i = 0; i < images.length; i++) {
          var image = images[i];
          await new Promise(function (resolve, reject) {
            new Compressor(image, {
              strict: true,
              quality: 0.8,
              width: 1024,
              mimeType: "image/jpeg",
              convertTypes: ["image/png", "image/jpeg", "image/gif", "image/heic", "image/webp", "image/heif"],
              convertSize: "Infinity",
              success(result){
                formData.append("images[]", result);
                resolve(result);
              },
              error(error){
                console.log("Error", error);
                reject(error);
              }
            })
          })
        };

        if (
          this.$store.state.watchProtectionImage != null &&
          this.$store.state.watchProtectionImage != undefined
        ) {
          const watchProtectionImage = this.$store.state.watchProtectionImage;
          if (watchProtectionImage && watchProtectionImage.length != 0) {
            for (let i = 0; i < watchProtectionImage.length; i++) {
              var image = watchProtectionImage[i];
              await new Promise(function (resolve, reject) {
                new Compressor(image, {
                  strict: true,
                  quality: 0.8,
                  width: 1024,
                  mimeType: "image/jpeg",
                  convertTypes: ["image/png", "image/jpeg", "image/gif", "image/heic", "image/webp", "image/heif"],
                  convertSize: "Infinity",
                  success(result){
                    formData.append("watchProtectionImage[]", result);
                    resolve(result);
                  },
                  error(error){
                    console.log("Error", error);
                    reject(error);
                  }
                })
              })
            }
          }
        }

        if (
          this.$store.state.warrantyImage != null &&
          this.$store.state.warrantyImage != undefined
        ) {
          const warrantyImage = this.$store.state.warrantyImage;
          if (warrantyImage && warrantyImage.length != 0) {
            for (let i = 0; i < warrantyImage.length; i++) {
              var image = warrantyImage[i];
              await new Promise(function (resolve, reject) {
                new Compressor(image, {
                  strict: true,
                  quality: 0.8,
                  width: 1024,
                  mimeType: "image/jpeg",
                  convertTypes: ["image/png", "image/jpeg", "image/gif", "image/heic", "image/webp", "image/heif"],
                  convertSize: "Infinity",
                  success(result){
                    formData.append("warrantyImage[]", result);
                    resolve(result);
                  },
                  error(error){
                    console.log("Error", error);
                    reject(error);
                  }
                })
              })
            }
          }
        }

        let services = this.$store.state.selectedRepairServices;

        services.forEach((element) => {
          if (element.backup !== undefined) {
            element.originalPrice = element.backup;
          } else {
            element.originalPrice = element.price;
          }
          element.displayPrice = element.price;
        });

        for (let i = 0; i < services.length; i++) {
          formData.append("services[]", JSON.stringify(services[i]));
        }

        formData.append("isClock", this.$store.getters.isClock);
        formData.append("isJewelry", this.$store.getters.isJewelry);

        formData.append(
          "overview",
          JSON.stringify(this.$store.state.overviewData)
        );

        if (
          this.$store.state.orderProtectionInfo != null &&
          this.$store.state.orderProtectionInfo != undefined
        ) {
          formData.append(
            "orderProtectionInfo",
            JSON.stringify(this.$store.state.orderProtectionInfo)
          );
        }

        if (
          this.$store.state.conditionDescription != null &&
          this.$store.state.conditionDescription != undefined
        ) {
          formData.append(
            "conditionDescription",
            this.$store.state.conditionDescription
          );
        }

        Object.keys(this.$store.state.checkoutFormData).forEach((key) =>
          formData.append(key, this.$store.state.checkoutFormData[key])
        );

        grecaptcha.ready(() => {
          grecaptcha
            .execute("6Ld-2D0jAAAAAO_Opw2GEf2isCYtdWF_X1l_8fiE", {
              action: "order",
            })
            .then((token) =>  {
              let req = { response: token };
              axios
                .post(process.env.VUE_APP_DABURL + `api/recaptcha`, req)
                .then((response) => {
                  let score = JSON.parse(response.data.result).score
                  if(score > 0.5){
                    axios
                    .post(process.env.VUE_APP_DABURL + "api/order", formData)
                    .then((response) => {
                      this.$store.commit("clear");
                      this.spinnerActive = false;
                      this.isLoading = false;
                      this.$router.push({ name: "Success" }).catch((error) => {
                        console.log(error);
                      });
                    })
                    .catch((e) => {
                      console.log(e);
                      this.$store.commit("clear");
                      this.$router.push({ name: "Error" }).catch((error) => {
                        console.log(error);
                      });
                      this.spinnerActive = false;
                      this.isLoading = false;
                    });
                  } else{
                    console.log("Score unter 0.5");
                    this.spinnerActive = false;
                  }
                 
                })
                .catch((error) => {
                  console.log(error);
                  this.spinnerActive = false;
                });
            });
        });
      }
    }, 
  },
};
</script>
